<template>
  <div class="card">
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <form>
      <div class="card-content">
        <div class="row">
          <div class="col-md-6">

            <div class="form-group">
              <label>{{$t('catalogCateg.name')}}</label>
              <input type="text"
                     name="name"
                     :placeholder="$t('catalogCateg.name')"
                     v-validate="modelValidations.name"
                     v-model="model.name"
                     class="form-control">
              <small class="text-danger" v-if="errors.has('name')">
                {{ getError('name') }}
              </small>
            </div>
            <!--   <div class="form-group">
              <label>Sort Order</label>
              <input type="number"
                     name="sort_order"
                     v-validate="modelValidations.sort_order"
                     v-model="model.sort_order"
                     class="form-control">
              <small class="text-danger" v-if="errors.has('sort_order')">
                {{ getError('sort_order') }}
              </small>
            </div> -->
            <div class="form-group">
              <label>{{$t('catalogCateg.displayType')}}</label>
              <!--  <select name="display_type" class="form-control"
                            v-model="model.display_type">
                <option v-for="(opt, key) in displayTypes"
                            :value="key"
                            :selected="key === model.display_type">{{opt}}</option>
              </select> -->
              <br/>
              <p-radio v-for="(opt, key) in displayTypes"
                :key="key"
                v-model="model.display_type"
                :label="key"
                :inline="true"
                :disabled="key === 'grid'">{{opt}}</p-radio>
              <small class="text-danger" v-if="errors.has('display_type')">
                {{ getError('display_type') }}
              </small>
            </div>
            <!-- <div class="form-group">
              <label>Parent Category</label>
              <select name="parent_id" class="form-control"
                            v-model="model.parent_id">
                <option :value="null" :selected="true">None</option>
                <template v-for="option in mainCategories">
                  <option v-if="option.id != $route.params.id"
                             :selected="option.id === model.parent_id"
                             :value="option.id"
                             :label="option.name"
                             :key="option.id"></option>
                </template>
              </select>
              <small class="text-danger" v-if="errors.has('parent_id')">
                {{ getError('parent_id') }}
              </small>
            </div> -->
            <div class="form-group">
              <label>{{$t('catalogCateg.shortDescription')}}</label>
              <textarea rows="5"
                     name="description"
                     :placeholder="$t('catalogCateg.shortDescription')"
                     v-validate="modelValidations.description"
                     v-model="model.description"
                     class="form-control"></textarea>
              <small class="text-danger" v-if="errors.has('description')">
                {{ getError('description') }}
              </small>
            </div>
            <div class="form-group">
              <label>{{$t('catalogCateg.validFromTo')}}</label>
              <el-date-picker type="daterange"
                              v-model="model.fromto"
                              value-format="yyyy-MM-dd"
                              format="dd/MM/yyyy"
                              :picker-options="pickerOptions">
              </el-date-picker>
              <small class="text-danger" v-if="errors.has('date_validfrom')">
                {{ getError('date_validfrom') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>{{$t('catalogCateg.image')}}</label>
              <el-upload
                action=""
                ref="upload"
                :limit="2"
                :file-list="model.imagelist"
                list-type="picture-card"
                accept=" .jpg, .jpeg, .png"
                :on-change="handleImgChnage"
                :on-exceed="handleExceed"
                :on-remove="handleRemove"
                :auto-upload="false">
                <i class="el-icon-plus"></i>
                <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer " >
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-success">{{$t('general.save')}}</button>
        <a v-if="!isNew()" @click.prevent="handleDelete('delete')" title="Delete" class="btn btn-danger btn-fill "> {{$t('general.delete')}} {{$t('catalogCateg.single')}}</a>
        <a v-if="isNew()" @click.prevent="handleDelete('cancel')" class="btn btn-danger btn-fill">{{$t('general.cancel')}}</a>
        <div style="clear: both"></div>
      </div>

    </form>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Checkbox, CheckboxGroup, Dialog} from 'element-ui'
  import moment from 'moment'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Dialog)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      [Dialog.name]: Dialog
    },
    computed: {
      ...mapFields(['name', 'description', 'sort_order', 'parent_id', 'date_validfrom', 'date_validto', 'display_type'])
    },
    data () {
      return {
        pickerOptions1: {
          // onPick (dates) {
            // if (dates.minDate !== 'undefined' && dates.maxDate !== 'undefined') {
            //   console.warn(this)
            //   this.updateDates(dates)
            // }
          // }
        },
        deliveryServices: [],
        pickerNames: ['date_validfrom', 'date_validto'],
        pickerOptions: {
          disabledDate (time) {
            if ((time.getTime() + 86401 * 1000) < Date.now()) {
              return true
            } else {
              return false
            }
          }
        },
        displayTypes: {
          'list': 'List',
          'grid': 'Grid'
        },
        mainCategories: [],
        model: {
          parent_id: null,
          display_type: 'list'
        },
        filelist: [],
        filelistToUpload: [],
        generalSuccess: '',
        modelValidations: {
          name: {
            required: true,
            min: 4
          }
        },
        loading: true
      }
    },
    created: function () {
      this.$nextTick(function () {
        this.loading = true
      })
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      var self = this
      // get main categories
      // this.apiRequest('/category', 'GET', data, function (response) {
      //   if (response.status === true) {
      //     self.mainCategories = response.data
      //   }
      // })
      // get category data
      if (this.$route.params.id) {
        var id = this.$route.params.id

        this.apiRequest('/category/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            if (response.data[0].date_validfrom && response.data[0].date_validto) {
              response.data[0].fromto = [response.data[0].date_validfrom, response.data[0].date_validto]
            }
            if (response.data[0].image) {
              response.data[0].imagelist = [{url: response.data[0].image}]
            } else {
              response.data[0].imagelist = []
            }
            // force list display
            response.data[0].display_type = 'list'
            self.model = response.data[0]

            self.$nextTick(function () { self.loading = false })
          }
        })
      } else {
        self.$nextTick(function () { self.loading = false })
      }

      var allTypes = this.$session.get('defaultData')['delivery_types']
      var locations = this.$session.get('selectedCompanyData')['locations_details']
      var enabled = []
      var enabledTypes = []

      for (let loc of locations) {
        for (let ordering of loc['ordering_management']) {
          console.warn(ordering)
          if (ordering['enabled'] === true) {
            enabled[ordering['type']] = true
          }
        }
      }
      console.warn(enabled)
      for (let idx in allTypes) {
        console.warn(idx)
        if (enabled[idx.toLowerCase()] !== undefined) {
          enabledTypes.push(allTypes[idx])
        }
      }
      console.warn(enabledTypes)
      this.deliveryServices = enabledTypes
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          // this.$emit('on-submit', this.registerForm, isValid)
          if (isValid) {
            this.errors.clear()
            this.saveCategory()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
                // console.warn(prop)
            this.errors.add(prop, errors[prop])
          }
        }
      },
      isNew () {
        if (this.$route.params.id) {
          return false
        } else {
          return true
        }
      },
      handleImgChnage (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
      },
      handleRemove (file, fileList) {
        console.log('handleRemove')
        if (fileList.length === 0) {
          this.model.imagelist = []
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: this.$t('general.removePhoto'),
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
        return isOkSize
      },
      updateDates (dates) {
        this.model.date_validfrom = moment(String(dates.minDate)).format('YYYY-MM-DD')
        this.model.date_validto = moment(String(dates.maxDate)).format('YYYY-MM-DD')
      },
      handleDelete (label) {
        var btnCounter = 3
        var self = this
        swal({
          text: this.$t('catalogCateg.areYouSure', {label: label}),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            if (this.isNew()) {
              self.$router.push('/categories')
            } else {
              var id = this.$route.params.id
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/category/' + id, 'DELETE', data, function (response) {
                console.warn(response)
                if (response.status === true) {
                  swal(
                    '',
                    self.$t('catalogCateg.categDeleted'),
                    'success'
                  )
                  self.$router.push('/categories')
                } else {
                  swal(
                    '',
                    response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
                    'error'
                  )
                }
              })
            }
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = self.$t('general.yes')
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      saveCategory () {
        this.$nextTick(function () {
          this.loading = true
        })
        var data = this.model
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        console.warn(data.fromto)
        if (data.fromto && data.fromto[0] && data.fromto[1]) {
          data.date_validfrom = data.fromto[0]
          data.date_validto = data.fromto[1]
        } else {
          data.date_validfrom = null
          data.date_validto = null
        }

        var self = this

        if (this.isNew()) {
          delete data.parent_category
          delete data.image
          this.apiRequest('/category', 'POST', data, function (response) {
            if (response.status === true) {
              console.warn(response)
              var id = response.data[0].id
              data.id = id
              data.sort_order = id
              self.apiRequest('/category/' + id, 'PUT', data, function (response2) {
              })
              if (data.imagelist && data.imagelist[0].status === 'ready') {
                self.getBase64(data.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.image = base64enc
                    console.warn(data2)
                    self.apiRequest('/category/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('catalogCateg.categAdded'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                        self.$router.push('/categories/edit/' + id)
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('catalogCateg.couldNotSave'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.$nextTick(function () { self.loading = false })
                swal(
                  {
                    title: '',
                    text: self.$t('catalogCateg.categAdded'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                ).catch(() => {})
                self.$router.push('/categories/edit/' + id)
              }
            } else {
              self.$nextTick(function () { self.loading = false })
              self.handleErrors(response.errors)
            }
          })
        } else {
          var id = this.$route.params.id
          delete data.parent_category
          delete data.image
          // check if the've removed the picture
          if (data.imagelist === 0) {
            data.image = ''
          }
          this.apiRequest('/category/' + id, 'PUT', data, function (response) {
            if (response.status === true) {
              if (data.imagelist[0].status && data.imagelist[0].status === 'ready') {
                self.getBase64(data.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.image = base64enc
                    console.warn(data2)
                    self.apiRequest('/category/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('catalogCateg.categUpdated'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('catalogCateg.couldNotSave'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.$nextTick(function () { self.loading = false })
                swal(
                  {
                    title: '',
                    text: self.$t('catalogCateg.categUpdated'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                ).catch(() => {})
              }
            } else {
              self.$nextTick(function () { self.loading = false })
              self.handleErrors(response.errors)
            }
          }) // end api response
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Categories/CategoryForm.vue